import ShopService from './shop-service';
import EventBus from './event-bus';
import { EVENTS } from './constants';

export default {
    track,
}

let eatself_facebook = 1900828563551035;
let eatself_google = "G-EV4KDT2YRY";
let ShopId = null;
EventBus.$on(EVENTS.clientLogin, (client) => {
    window.hj?.('identify',client?.ClientId, client);
})

function track(eventName: string, params: {[key: string]: any }) {
    try {
        let shop = ShopService.shop;
        if (ShopId && shop.ShopId != ShopId) {
            remove_trackers();
            ShopId = null;
        }
        if (!ShopId) {
            ShopId = shop.ShopId;
            install_fbq(eatself_facebook);
            install_gtag(eatself_google);
            install_fbq(shop.info.trackers.fbq);
            install_gtag(shop.info.trackers.gtag);
        }
        // using fb standard events Api https://developers.facebook.com/docs/meta-pixel/reference#standard-events
        params = {...params,ShopId};

        if (window.fbq) fbq('track',eventName,params);
        if (window.gtag) gtag('event',eventName,params);
        if (window.fbq || window.gtag) console.log('track', eventName, params);
        if (window.hj) window.hj('event', eventName);

    } catch(e) {
        console.error(e);
    }
}
function remove_trackers() {
    // facebook
    window.fbq = null;
    // DONT remove google, i dont know how to remove previously installed trackers,
    // the following code just disables tracking;
    // we should still be able to filter by ShopId
    // let el = document.getElementById("ga-gtag");
    // el?.parentNode.removeChild(el);
    // window.dataLayer = [];
}

function install_fbq(pixel_id) {
    function a(f,b,e,v,n,t,s) {
        if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)
    }

    a(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');

    fbq('init',pixel_id);
}

function install_gtag(gtag_id) {
    // if (!window.dataLayer) {
    if (!window['ga-gtag']) {
        const s = document.createElement('script');
        s.id = 'ga-gtag';
        s.setAttribute('src', 'https://www.googletagmanager.com/gtag/js'); // ?id=UA-MYGOOGLEID
        s.async = true;
        document.head.appendChild(s);

        window.dataLayer = window.dataLayer || [];
        window.gtag = function() {
            window.dataLayer.push(arguments);
        }

        gtag('js', new Date());
    }
    gtag('config', gtag_id);
}